<section>
    <article class="flex justify-center items-center">
        <img [src]="images.pax" [ngClass]="{'filter-neutrals-grey-04': booking.cancelled}" alt="pax" class="h-6 w-6">
        <label class="ml-2" [ngClass]="{'text-neutrals-grey-04': booking.cancelled}" >{{ booking.seats }}</label>
    </article>
    <article class="flex justify-center items-center">
        <img [src]="images.prm" [ngClass]="{'filter-neutrals-grey-04': booking.cancelled}" alt="prm" class="h-6 w-6">
        <label class="ml-2" [ngClass]="{'text-neutrals-grey-04': booking.cancelled}" >{{ booking.prmSeats }}</label>
    </article>
</section>
